import { CenteredDiv } from "./CenterDiv.styles";

export const CenterDiv = ({ ...props }) => {
  return <CenteredDiv>{props.children}</CenteredDiv>;
};
